import React from 'react';

/**
 * InfoPoint Albania official mark.
 * Modern luxury tourism: pavilion / dome silhouette + minimalist "i".
 */
export const Logo = ({ size = 36, className = '', monochrome = false }) => {
  const gradient = !monochrome;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      {gradient ? (
        <defs>
          <linearGradient id="ipa-logo-g" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#00C77A" />
            <stop offset="1" stopColor="#008F5A" />
          </linearGradient>
        </defs>
      ) : null}
      <path
        d="M32 2 C18 2 7 13 7 27 c0 12 10 22 21 32 c1.5 1.3 4.5 1.3 6 0 c11 -10 22 -20 22 -32 C56 13 45 2 32 2 Z"
        fill={gradient ? 'url(#ipa-logo-g)' : '#00AA6C'}
      />
      {/* Pavilion arches inside */}
      <path d="M32 12 C24 12 17 17 17 27 c0 4 3 7 7 7 h17 c4 0 7 -3 7 -7 c0 -10 -7 -15 -16 -15 Z" fill="#ffffff" fillOpacity="0.15"/>
      {/* i dot */}
      <circle cx="32" cy="20" r="4" fill="#fff" />
      {/* i stem */}
      <path d="M28 28 h8 v22 h-8 z" fill="#fff" />
    </svg>
  );
};
